var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "video-thumbnail-inline",
      class: _vm.getVariant("video-thumbnail-inline"),
      on: { click: _vm.clickVideo }
    },
    [
      _c(
        "figure",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.playing,
              expression: "!playing"
            }
          ],
          staticClass: "video-thumbnail-inline__image"
        },
        [
          _vm._t("image"),
          _c(
            "div",
            { staticClass: "video-thumbnail-inline__icon" },
            [
              _c("icon-play-view", {
                staticClass: "animate",
                attrs: { "has-title": false, loading: _vm.loading }
              })
            ],
            1
          )
        ],
        2
      ),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.playing,
              expression: "playing"
            }
          ],
          staticClass: "video-thumbnail-inline__video"
        },
        [
          _c("video-fullscreen-inline-view", {
            attrs: { "video-id": _vm.videoId, loading: _vm.loading },
            on: {
              "start-playing": function($event) {
                return _vm.onStartPlaying()
              },
              "stop-playing": function($event) {
                return _vm.onStopPlaying()
              }
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2185a5b2", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2185a5b2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/video/video-thumbnail-inline-view.vue
// module id = 287
// module chunks = 47 80